import { useMemo } from 'react';
import { useBusinessMeta, useCashRegisterData } from '../../../contexts/dataContextSlices';

/**
 * Worker sessions + legacy invoice payments (Strangler over DataContext).
 */
export function useCashRegisterDomain() {
  const meta = useBusinessMeta();
  const cashRegister = useCashRegisterData();

  return useMemo(
    () => ({
      ...cashRegister,
      currentBusinessId: meta.currentBusinessId,
      ready: meta.ready,
      dataLoaded: meta.dataLoaded
    }),
    [meta, cashRegister]
  );
}
